import { css } from '@emotion/react'
import { spacing } from 'gin-and-tonic/foundation/spacing'
import { fontSize } from 'gin-and-tonic/foundation/fontSize'

export const containerStyles = css`
  align-items: center;
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  margin: ${spacing.X20} auto;
  width: 100%;
  max-width: 640px;
`
export const formStyle = css`
  width: 100%;
`
export const fieldsetStyle = css`
  border-style: none;
  margin-bottom: ${spacing.X20};
  width: 100%;
`
export const legendStyle = css`
  border-bottom: 1px solid grey;
  font-size: ${fontSize.X15};
  font-weight: 600;
  padding-bottom: ${spacing.X12};
  margin-bottom: ${spacing.X20};
  width: 100%;
`
export const fieldRowStyle = css`
  display: grid;
  grid-template-columns: 1fr 2fr;
  align-items: center;
`
export const labelStyle = css`
  display: inline-block;
  text-align: right;
  font-weight: 600;
  padding: 0 ${spacing.X8};
`
export const inputLabelStyle = css`
  ${labelStyle};
  padding-bottom: ${spacing.X12};
`
export const inputOuterStyles = css`
  margin-left: 0;
  margin-right: 0;
`
export const checkboxContainerStyle = css`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  width: 100%;
`
export const checkboxItemStyle = css`
  margin-bottom: ${spacing.X12};
  width: 33%;
`
